module.exports = __webpack_public_path__ + "static/img/AF.ddb5dd4d.png";